'use client';

import { AppContextProvider } from '@/components/App';
import ToastContainer from '@/components/ToastContainer';
import { trackingIds } from '@/constants/tracking-ids';
import { useAdapter } from '@/hooks/Adapter/useAdapter';
import { ApolloProvider } from '@apollo/client';
import NoSsr from '@mui/material/NoSsr';
import { usePathname } from 'next/navigation';
import { Suspense, useEffect } from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { SearchParamsRecorder } from './search-params-recorder';
import useAliyunRUM from './use-aliyun';
import { useGA4 } from './use-ga4';
import { useGTM } from './use-gtm';
import useReplaceAllPolyfill from './use-replace-all-polyfill';

const Adapter = props => {
  const { navigation } = props;

  const { apolloProps, reduxProps } = useAdapter(props);

  const pathname = usePathname();

  useAliyunRUM();
  useReplaceAllPolyfill();

  useGTM({ id: trackingIds.gtmId });

  useGA4();

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname]);

  const children = props.children;

  return (
    <ApolloProvider {...apolloProps}>
      <ReduxProvider {...reduxProps}>
        <AppContextProvider>
          <NoSsr>{children}</NoSsr>
          {navigation}
          <ToastContainer />
          <Suspense>
            <SearchParamsRecorder />
          </Suspense>
        </AppContextProvider>
      </ReduxProvider>
    </ApolloProvider>
  );
};

export default Adapter;
